import { Indicator } from './indicator';

export enum IndicatorAlertType {
  DEFAULT = 'default',
  WALLET = 'wallet',
  FUND = 'fund',
  QUOTA = 'quota',
}

export enum IndicatorAlertCriticalityEnum {
  ALERT = 'alert',
  CRITICAL = 'critical',
}

export type IndicatorAlertConfiguration = {
  id: number | null;
  type: IndicatorAlertType;
  entityId: string | number;
  indicator: Indicator;
  criteriaStartValue: number;
  criteriaEndValue: number | null;
  criteriaOperator: 'gt' | 'lt' | 'gte' | 'lte' | 'between';
  criticality: IndicatorAlertCriticalityEnum;
  isActive: boolean;
  email: boolean;
  alertConfigurationId?: number | null;
  sharedEntityId?: number | null;
};

// Novos tipos para suportar múltiplos alertas por indicador
export type AlertConfiguration = {
  id: number | null; // ID do backend (null para novos alertas)
  internalId: string; // ID interno único (sempre presente para identificação)
  type: IndicatorAlertType;
  entityId: number;
  indicator: string;
  startValue: number;
  endValue?: number;
  operator: 'gt' | 'lt' | 'gte' | 'lte' | 'between';
  criticality: IndicatorAlertCriticalityEnum;
  isActive: boolean;
  email: boolean;
  alertConfiguration?: number;
  tabType: 'percentage' | 'amount';
};

export type IndicatorWithAlerts = {
  key: string; // accessorKey do indicador
  label: string; // header do indicador
  valueType: 'percentage' | 'amount';
  alerts: AlertConfiguration[]; // Array de alertas para este indicador
};
